import { compose } from 'recompose'
import { injectIntl } from 'react-intl'
import mapValues from 'lodash/mapValues'
import {
  ShortBullets,
  DetailsBullets,
  DetailsHeadline,
  LoanName,
} from './RefiMessages'

export default mapValues(
  {
    ShortBullets,
    DetailsBullets,
    DetailsHeadline,
    LoanName,
  },
  v => compose(injectIntl)(v)
)
